// @flow
import React, { Component } from 'react';

import { copyToClipboard } from '../utilities/copyToClipboard';
import { Mobile, Default } from './Responsive';
import { PrimaryButton } from './ButtonStyles';
import { BlueStyledLink } from './LinkStyles';
import {
  ReferralLinkDiv,
  ReferralOptionCopyDiv,
  ReferralUrlA,
  CopyButtonA
} from './ReferralLinkStyles';

type BaseProps = {
  title?: string,
  icon?: string,
  className?: string
};
type CopyProps = {
  ...$Exact<BaseProps>,
  copyableUrl: string,
  linkText?: void,
  linkTo?: void
};

type LinkProps = {
  ...$Exact<BaseProps>,
  copyableUrl?: void,
  linkText: string,
  linkTo: string
};

type Props = CopyProps | LinkProps;

export default class ReferralLink extends Component<Props> {
  handleCopy = () => {
    copyToClipboard(this.props.copyableUrl);
  };

  render() {
    const { copyableUrl } = this.props;
    return (
      <ReferralLinkDiv className={this.props.className}>
        <h5>{this.props.title}</h5>
        <p>
          Share this link with your direct merchants to register for a
          cryptocurrency account through Netcents. Once they create an account
          you will be able to track their progress and transactions from your
          dashboard.
        </p>
        {typeof copyableUrl === 'string' ? (
          <ReferralOptionCopyDiv>
            <ReferralUrlA href={copyableUrl}>{copyableUrl}</ReferralUrlA>
            <Mobile>
              <PrimaryButton onClick={this.handleCopy}>Copy Link</PrimaryButton>
            </Mobile>
            <Default>
              <CopyButtonA onClick={this.handleCopy}>Copy</CopyButtonA>
            </Default>
          </ReferralOptionCopyDiv>
        ) : (
          <BlueStyledLink to={this.props.linkTo} styled={{ bold: true }}>
            {this.props.linkText}
          </BlueStyledLink>
        )}
      </ReferralLinkDiv>
    );
  }
}
